import { IRefIds } from 'constants/refs';
import { get } from 'services/request';
import { IGridData } from '../types/models';
import { BaseModel } from './BaseModel';

export type ICheckerRef = {
  ref: IRefIds;
  name: string;
  batchSize: number;
};

export default class ConceptLinkerCheckerModel extends BaseModel<IGridData, ICheckerRef[]> {
  async loadItemData(itemId = 0) {
    return await get<ICheckerRef[]>(`concepts-linker/checker-refs`);
  }
}
